import type { PensionFormInput } from "web_myplann/Portfolio/Forms/PensionForm/pensionFormSchema";

export const PENSION_FORM_DEFAULT_VALUES: PensionFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	signedAt: null,
	startAt: null,
	endAt: null,
	payment: null,
	paymentFrequency: null,
};
